import validate from "/opt/rusdram/packages/client/node_modules/nuxt/dist/pages/runtime/validate.mjs";
export const globalMiddleware = [
  validate
]
export const namedMiddleware = {
  auth: () => import("/opt/rusdram/packages/client/middleware/auth.js")
}